
  <template>
  <div class="register-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page register-page section-image" filter-color="black">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-lg-5 col-md-5 ml-auto">
                <info-section
                  class="mt-5"
                  type="primary"
                  title="Influencer Campaigns"
                  description="See the impact of influencer campaigns on your brand."
                  icon="nc-icon nc-tv-2"
                ></info-section>
                <info-section
                  type="primary"
                  title="Grow your Instagram"
                  description="Track your growth. Increase your engagement and reach."
                  icon="nc-icon nc-html5"
                ></info-section>

                <info-section
                  type="primary"
                  title="Built Audience"
                  description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                  icon="nc-icon nc-atom"
                ></info-section>
              </div>
              <div class="col-lg-4 col-md-6 mr-auto">
                <card type="signup" class="text-center" style="margin-top:0px;">
                  <div
                    class="alert alert-dismissible fade show"
                    :class="alertType"
                    v-if="showAlert==true"
                  >
                    <button
                      type="button"
                      aria-hidden="true"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <i class="nc-icon nc-simple-remove"></i>
                    </button>

                    <div>
                      <span>{{alertMsg}}</span>
                    </div>
                  </div>
                  <template slot="header">
                    <h4 class="card-title">Register</h4>
                  </template>

                  <fg-input
                    v-model="model.email"
                    v-validate="modelValidations.email"
                    name="email"
                    type="text"
                    :error="getError('email')"
                    addon-left-icon="nc-icon nc-email-85"
                    placeholder="Email..."
                  ></fg-input>
                  <fg-input
                    v-model="model.password"
                    v-validate="modelValidations.password"
                    name="password"
                    type="password"
                    :error="getError('password')"
                    placeholder="Enter Password"
                  ></fg-input>
                  <fg-input
                    v-model="model.confirmPassword"
                    v-validate="modelValidations.confirmPassword"
                    name="confirmPassword"
                    type="password"
                    :error="getError('confirmPassword')"
                    placeholder="Confirm Password"
                  ></fg-input>
                  <p-checkbox class="text-left" v-model="form.acceptTerms">
                    I agree to the
                    <a href="#something">terms and conditions</a>.
                  </p-checkbox>

                  <p-button
                    slot="footer"
                    type="info"
                    round
                    @click="signup"
                    style="z-index: 100;"
                  >Get Started</p-button>
                </card>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(/static/img/background/jan-sendereks.jpg) "
        ></div>
      </div>
    </div>
  </div>

</template>




<script>
import firebase from "firebase";
import axios from "axios";
import { mapActions } from "vuex";
import VueCookies from "vue-cookies";
import AppNavbar from "@/components/Dashboard/Views/Pages/Layout/AppNavbar";
import AppFooter from "@/components/Dashboard/Views/Pages/Layout/AppFooter";
import {
  Card,
  Checkbox,
  Button,
  InfoSection
} from "src/components/UIComponents";
import {
  clientInviteReadApi,
  clientInviteCheckApi,
  clientMemberAddApi,
  userExistsApi,
  userCreateApi
} from "@/config/appSettings";
export default {
  name: "signup",
  components: {
    Card,
    AppNavbar,
    AppFooter,
    InfoSection,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      inviteDetails: null,
      email: null,
      password: "",
      confirmPassword: "",
      show: false,
      alertMsg: null,
      alertType: null,
      showAlert: null,
      displayAlert: false,
      auth: null,
      form: {
        firstName: "",
        lastName: "",
        email: "",
        acceptTerms: true
      },
      model: {
        firstName: "",
        lastName: "",
        email: ""
      },
      modelValidations: {
        password: {
          required: true,
          min: 6
        },
        confirmPassword: {
          required: true,
          passwordMatch: true,
          min: 6
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },
  methods: {
    ...mapActions(["emailContactCreate"]),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        //console.log("CHECKING IS VALID:", isValid);
        //console.log("CHECKING REGISTER FORM: ", this.registerForm);
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },

    async signup(e) {
      e.preventDefault();
      let self = this;
      console.log("SENDING SIGNUP");
      self.showAlert = false;
      self.alertType = null;
      self.alertMsg = null;

      if (self.model.password !== self.model.confirmPassword) {
        self.showAlert = true;
        self.alertType = "alert-danger";
        self.alertMsg = "Please confirm password.";
        return;
      }

      if ((await this.$validator.validateAll()) === true) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(self.model.email, self.model.password)
          .then(
            () => {
              //console.log(JSON.stringify(user));
              // alert(`Account Created for ${user}`);
              self.auth = firebase.auth().currentUser.uid;
              firebase
                .auth()
                .currentUser.sendEmailVerification()
                .then(function() {
                  let newUser = {};
                  newUser.usertoken = self.auth;
                  newUser.email = self.model.email;
                  newUser.profileType = "client";
                  newUser.source = {
                    type: "clientInvite",
                    inviteId: self.$route.params.inviteId
                  };
                  axios.post(userCreateApi, newUser).then(newUserResponse => {
                    console.log(
                      "HERE IS THE NEW USER RESPONSE:",
                      newUserResponse
                    );
                    if (newUserResponse.data.success === true) {
                      // CREATE NEW USER
                      self.memberCreate();
                      self.$router.push({
                        path: "/login",
                        query: {
                          msg_show: true,
                          msg_type: "success",
                          msg: "Your're signed up! Log In below."
                        }
                      });
                    }
                  });
                })
                .catch(function(err) {
                  // Handle Errors here.

                  console.log("There was an error: ", err);
                  if (err.code === "auth/invalid-email") {
                    self.alertMsg = "Please enter a valid email.";
                    self.showAlert = true;
                    self.alertType = "alert-danger";
                  }
                  if (err.code === "auth/user-not-found") {
                    self.alertMsg = "Please enter a valid email.";
                    self.showAlert = true;
                    self.alertType = "alert-danger";
                  } else {
                    self.alertMsg = err.message;
                    self.showAlert = true;
                    self.alertType = "alert-danger";
                  }

                  self.displayAlert = true;

                  self.showAlert = true;
                  self.alertType = "alert-danger";
                });
            },
            err => {
              console.log("There was an error: ", err);
              if (err.code === "auth/invalid-email") {
                self.alertMsg = "Please enter a valid email.";

                self.showAlert = true;
                self.alertType = "alert-danger";
                return;
              }
              if (err.code === "auth/user-not-found") {
                self.alertMsg = "Please enter a valid email.";

                self.showAlert = true;
                self.alertType = "alert-danger";
                return;
              } else {
                self.alertMsg = err.message;
                self.showAlert = true;
                self.alertType = "alert-danger";
                return;
              }
            }
          );
      }
    },
    async loadInvite() {
      try {
        let clientInviteResponse = await axios.get(
          `${clientInviteReadApi}/?invite=${this.$route.params.inviteId}`
        );

        console.log("INVITE LOAD RESPONSE:", clientInviteResponse.data);

        if (clientInviteResponse.data.success === true) {
          this.inviteExists = true;
          this.email = clientInviteResponse.data.result.email;
          this.inviteDetails = clientInviteResponse.data.result;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR: ", err);
      }
    },
    async inviteCheck() {
      try {
        let clientInviteCheckResponse = await axios.get(
          `${clientInviteCheckApi}/?invite=${this.$route.params.inviteId}`
        );
        console.log("INVITE CHECK RESPONSE:", clientInviteCheckResponse.data);

        if (clientInviteCheckResponse.data.success === true) {
          this.email = clientInviteCheckResponse.data.result.email;
          console.log("CHECKING EMAIL:", this.email);
          this.inviteDetails = clientInviteCheckResponse.data.result;
        }

        if (clientInviteCheckResponse.data.complete === true) {
          // REDIRECT TO LOGIN PAGE
          if (typeof this.auth !== null) {
            this.$router.push("/dashboard");
            return;
          }
          this.$router.push("/login");
          return;
        }
        // CHECK IF USER LOGGED IN
        if (this.auth !== null) {
          // UPDATE THEN REDIRECT TO DASHBAORD
          await this.memberCreate();
          this.$router.push("/dashboard");
          return;
        }

        // IF USER EXISTS BUT NOT LOGGED IN
        let userCheckResponse = await axios.get(
          `${userExistsApi}/?email=${this.$route.params.inviteId}`
        );

        if (userCheckResponse.data.exists === true) {
          // UPDATE THEN REDIRECT TO LOGIN
          await this.memberCreate();
          this.$router.push("/login");
          return;
        }

        this.inviteExists = true;

        // CHECK IF USER IS SIGNED UP
      } catch (err) {
        console.log("THERE WAS AN ERROR: ", err);
      }
    },
    async memberCreate() {
      // REGISTER ADD MEMBER TO CAMPAIGN

      try {
        let newMember = {};
        newMember.usertoken = this.auth;
        newMember.client = this.inviteDetails.clientId;
        newMember.invite = this.$route.params.inviteId;
        await axios.post(clientMemberAddApi, newMember);
        //return;
      } catch (err) {
        console.log("ERROR: ", err);
        //return;
      }
    },
    async passwordRuleCheck() {
      if (this.password !== null) {
        return false;
      }
      if (this.password.length < 8) {
        return false;
      }
      return true;
    },
    async setCookie() {
      if (!VueCookies.isKey("client_ref")) {
        let cookieData = { invid: this.$route.params.inviteId };
        VueCookies.set("client_ref", cookieData, "1m");
        console.log("COOKIE SET: ", cookieData);
      }
      console.log("COOKIES EXIST: ", VueCookies.keys());
      console.log("COOKIE VALUE: ", VueCookies.get("client_ref"));
    }
  },
  mounted() {
    this.inviteCheck();
    this.setCookie();
    try {
      if (typeof firebase.auth().currentUser.uid !== "undefined") {
        this.auth = firebase.auth().currentUser.uid;
      }
    } catch (err) {}
  },
  created() {
    let self = this;
    this.$validator.extend("passwordMatch", {
      getMessage(field, val) {
        return "Passwords don't match.";
      },
      validate(value, field) {
        console.log("VALUE:", value);
        console.log("FIELD:", field);

        try {
          if (self.model.password !== self.model.confirmPassword) {
            return false;
          }
          if (self.model.password == self.model.confirmPassword) {
            return true;
          }
          return false;
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err);
          return false;
        }
      }
    });
  }
};
</script>

<style scoped>
.float-left {
  float: left;
}
.checkbox {
  margin: 10px;
  padding: 3px;
}
.margin-10 {
  margin: 10px;
}
.error-check {
  outline: 3px solid red;
}
</style>